import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-ellipsis",
  "use": "foquz-icon-ellipsis-usage",
  "viewBox": "0 0 19 4",
  "content": "<symbol viewBox=\"0 0 19 4\" fill=\"none\" id=\"foquz-icon-ellipsis\"><path d=\"M4.333 2a2 2 0 11-4 0 2 2 0 014 0zm7.001 0a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol